import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import NewsForm from "@/components/admin/NewsForm";
import NewsList from "@/components/admin/NewsList";

const empty = { title: "", content: "", category: "news" };

export default function NewsManager() {
  const [news, setNews] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = useCallback(() => api.get("/news").then((r) => setNews(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const reset = () => { setForm(empty); setEditId(null); };
  const submit = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.content.trim()) return toast.error("Uzupełnij tytuł i treść");
    try {
      await (editId ? api.put(`/news/${editId}`, form) : api.post("/news", form));
      toast.success(editId ? "Zapisano zmiany" : "Dodano wpis");
      reset(); load();
    } catch (err) { toast.error(errorText(err)); }
  };
  const edit = (n) => { setEditId(n.id); setForm({ title: n.title, content: n.content, category: n.category }); };
  const remove = async (id) => { await api.delete(`/news/${id}`); toast.success("Usunięto wpis"); load(); };

  return (
    <div className="grid lg:grid-cols-[380px_1fr] gap-10">
      <NewsForm form={form} setForm={setForm} editing={!!editId} onSubmit={submit} onCancel={reset} />
      <NewsList news={news} onEdit={edit} onRemove={remove} />
    </div>
  );
}
